module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-preview-ac773d4be31f7878cc6e2859219a498d.jpg";